// Seite für unbekannte Adressen (2026-11-04). nginx liefert dazu Status 404.
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import cfg from "@/seo-routes.json";

export default function NotFound() {
  useEffect(() => {
    document.title = cfg.notFound.title;
    const r = document.head.querySelector('meta[name="robots"]');
    if (r) r.setAttribute("content", "noindex, follow");
    const c = document.head.querySelector('link[rel="canonical"]');
    if (c) c.remove();
  }, []);
  return (
    <div className="min-h-screen bg-white font-sans text-concrete-900">
      <Navbar />
      <main className="pt-40 pb-24 px-4 md:px-12 text-center">
        <h1 className="text-3xl md:text-5xl font-heading font-bold text-black mb-4">Seite nicht gefunden</h1>
        <p className="text-concrete-600 mb-8 max-w-md mx-auto">Diese Seite gibt es nicht (mehr). Vielleicht hilft dir einer dieser Wege weiter.</p>
        <div className="flex gap-4 justify-center flex-wrap">
          <Link to="/" className="px-6 py-3 bg-black text-white rounded-full font-medium">Zur Startseite</Link>
          <Link to="/buchung" className="px-6 py-3 border border-black text-black rounded-full font-medium">Raum buchen</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
